import { ArrowDropDown } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import FilterChip from '../FilterChip';

const FilterGroupChip = ({ items, type, limitTags = 5 }) => {
  const displayedItems = useMemo(() => {
    if (!items?.length) return [];
    if (limitTags >= items?.length) return items;

    return [...items.slice(0, limitTags), { label: '...' }, { label: `+${items.length - limitTags}` }];
  }, [items, limitTags]);

  if (!items?.length) return null;

  return (
    <Tooltip
      title={
        <>
          {displayedItems.map((item, i) => (
            <div key={i}>{item.label}</div>
          ))}
        </>
      }
    >
      <Box>
        <FilterChip type={type} label={<ArrowDropDown />} />
      </Box>
    </Tooltip>
  );
};

FilterGroupChip.propTypes = {
  items: PropTypes.array,
  type: PropTypes.string,
  limitTags: PropTypes.number,
};

export default FilterGroupChip;
